import React from 'react';

// Digital HIG Components
// @ts-ignore
import DHBox from "@digital-hig/mui/Box";
// @ts-ignore
import DHButton from "@digital-hig/mui/Button";

interface PopupActionsProps {
  onClose: () => void;
  closeButtonText?: string;
}

export const PopupActions: React.FC<PopupActionsProps> = ({ 
  onClose, 
  closeButtonText = 'Close'
}) => {
  return (
    <DHBox
      sx={{
        height: '88px',
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        margin: 0,
        padding: 0
      }}
    >
      <DHButton
        variant="contained"
        onClick={onClose}
        sx={{
          fontFamily: 'Artifakt Element',
          fontWeight: 600,
          fontSize: '16px',
          lineHeight: '20px',
          letterSpacing: '0%',
          textAlign: 'center',
          textTransform: 'none',
          width: '81px',
          height: '40px'
        }}
      >
        {closeButtonText}
      </DHButton>
    </DHBox>
  );
};

